module.exports = __webpack_public_path__ + "static/media/as_item2_bg.70889b8c.png";